import { getTerminalMode } from './terminal';
import { IS_KIOSK_VENICE_MODE } from 'constants/app/configs';

export const isMobile = () => {
  // this check is temporary, until we have a proper solution for the terminal
  if (IS_KIOSK_VENICE_MODE && getTerminalMode()) {
    return false;
  }

  return window.innerWidth < 1024;
};
